<s1-input-label [grouped]="grouped" [label]="label" [appendLabel]="appendLabel">
  <input class="form-control {{ textAlignment }}" [ngClass]="{'is-invalid' : !checkIsValid() }" type="{{ type }}" [formControl]="control" [readonly]="readonly"/>
</s1-input-label>